import _ from 'lodash';

import { INIT } from 'client/constants';
import { getSettings, getCategories } from 'admin/actions';
import { getCategorySelection } from './get-category-selection';

export function init() {
	return async (dispatch, getState) => {
		try {
			dispatch({ type: INIT.START });

			await dispatch(getSettings());
			await dispatch(getCategories());

			const { categories } = getState();

			_.forEach(categories.data, ({ id }) => dispatch(getCategorySelection({ categoryId: id })));

			dispatch({ type: INIT.SUCCESS });
		} catch (e) {
			dispatch({ type: INIT.FAIL });
		}
	};
}
